/**
 * Text compared the way a person reads it — the client half of the API's
 * `SearchText`.
 *
 * Every business on the platform is Romanian and writes ă, â, î, ș and ț; the
 * people searching type on whatever keyboard they have. "pitesti" has to find
 * "Pitești", or a list that plainly contains the city looks empty.
 */

/** Lowercased, trimmed and stripped of diacritics. */
export const normalizeText = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/\p{Mn}/gu, "")
    .toLowerCase()
    .trim();

/** True when `haystack` contains `needle`, ignoring case and diacritics. */
export const matchesText = (haystack, needle) =>
  normalizeText(haystack).includes(normalizeText(needle));
